import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import face from "../../../view/Red/ico-facebook.png";
import twit from "../../../view/Red/ico-twitter.png";
import inst from "../../../view/Red/ico-instagram.png";
import { CopyToClipboard } from "react-copy-to-clipboard";

export function Red(){
  const [ copy, setCopy ] = useState("Copy");
  function chek() {
    if ( copy === "Copy" ) {
      setCopy("Copied");
    } else if ( copy === "Copied" ) {
      setCopy("Very good!!");
    } else {
      setCopy("Copied");
    }
  }
  const hiperAncle = { textDecoration: "none" };
  return (
    <td className="container-tbody" key={1}>
      <section className="column_facebook">
        <div>
          <Link to={"https://www.facebook.com"} style={hiperAncle} target="_blank">
            <p><b>Facebook</b></p>
            <img src={face} alt="ico_facebook" />
          </Link>
        </div>
      </section>
      <section className="column_twiter">
        <div>
          <Link to={"https://twitter.com"} style={hiperAncle} target="_blank">
            <p><b>Twitter</b></p>
            <img id="full-in" src={twit} alt="ico_twiter" />
          </Link>
        </div>
      </section>
      <section className="column_instagram">
        <div>
          <Link to={"https://www.instagram.com"} style={hiperAncle} target="_blank">
            <p style={{marginBottom:"4px"}}><b>Instagram</b></p>
            <img src={inst} alt="ico_instagram" />
          </Link>
        </div>
      </section>
      <section className="column_copy">
        <div className="container_copy">
          <p>Compartir URL coronadosdelbien</p>
          <CopyToClipboard text="https://www.coronadosdelbien.com">
            <button lang="en" className="bt_Copy" onClick={() => {chek();}}>
              {copy}
            </button>
          </CopyToClipboard>
        </div>
      </section>
      <br />
    </td>
  );
}
